import React from "react";
import "./organization-line-item.scss";

import { GSInfoGroup, GSImage, GSButton } from "golfstatus_react_components";

import { getDate } from "../helpers/Dates";
import {
  faFileContract, faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const OrganizationLineItem = (props) => {
  const {
    name,
    logo,
    createdAt,
    type,
    organizationType,
    facilities,
    stripeId,
    tosAcceptedAt,
    id,
  } = props;
  const navigate = useNavigate();
  const getImageLayout = () => {
    return (
      <GSImage
        src={logo}
        size={type === "compact" ? "x-small" : "medium"}
        ratio="wide"
      />
    );
  };
  const getType = () => {
    return organizationType !== "unknown"
      ? organizationType?.replace?.("_", " ")
      : "Default Organization";
  };
  const getFacilities = () => {
    const facilitySet = [...new Set(facilities?.map?.((f) => f.name))];
    return facilitySet.join?.(", ");
  };
  const getInfoGroup = () => {
    let imageGroup = {
      fit: "hide-mobile",
      sections: [
        {
          sectionItems: [{ value: getImageLayout() }],
        },
      ],
    };
    let infoGroup = {
      fit: "stretch",
      sections: [
        {
          sectionItems: [
            { type: "primary", value: name },
            { type: "secondary capitalize", value: getType() },
          ],
        },
      ],
    };

    const grp = [imageGroup, infoGroup];

    if (type !== "compact") {
      infoGroup.sections.push(
        {
          sectionItems: [
            { type: "secondary", value: getFacilities() },
          ],
        },
      );
      if (!tosAcceptedAt) {
        grp.push({
          sections: [
            {
              sectionItems: [
                {
                  type: " no-wrap hide-mobile",
                  value: (
                    <GSButton
                      buttonIcon={faFileContract
                      }
                      title="Review Terms"
                      type="black"
                    />
                  ),
                },
              ],
            },
          ],
        });
        
      } 
      else if(!stripeId){
        let stripeButton = <GSButton
        type="light-grey"
        title="Add Payment Method"
        buttonIcon={faPlusCircle}
        onClick={(e) => {
          if(tosAcceptedAt){
            navigate?.(`${id}/settings/payments`);
          }
          e?.stopPropagation?.();
        }}
      />
        grp.push(
          {
            sections: [
              {
                sectionItems: [
                  {
                    type: "no-wrap hide-mobile",
                    value: stripeButton,
                  },
                ],
              },
            ],
          }
        )
      }
      else {
        grp.push({
          sections: [
            {
              sectionItems: [
                {
                  type: "secondary no-wrap hide-mobile",
                  value: `Added on ${getDate(createdAt)}`,
                },
              ],
            },
          ],
        });
      }
      
    }

    

    return grp;
  };

  return (
    <organization-line-item class={type}>
      <GSInfoGroup
        type="list-item x-large-pad"
        dataGroups={getInfoGroup()}
      ></GSInfoGroup>
    </organization-line-item>
  );
};

export default OrganizationLineItem;
